import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';
import AuthModule from "@/store/modules/AuthModule";
import DataModule from "@/store/modules/DataModule";

Vue.use(Vuex);

const vuexLocal = new VuexPersistence({
    storage: window.localStorage,
});

export default new Vuex.Store({
    modules: {
        auth: AuthModule,
        data: DataModule,
    },
    getters: {
        productTypes(state: {auth: AuthModule, data: DataModule}) {
            return state.data.productTypes;
        },
        divisions(state: {auth: AuthModule, data: DataModule}) {
            return state.data.divisions;
        },
    },
    plugins: [vuexLocal.plugin],
});